import { render } from "./SponsorsSectionNew.vue?vue&type=template&id=1addfb07"
import script from "./SponsorsSectionNew.vue?vue&type=script&lang=js"
export * from "./SponsorsSectionNew.vue?vue&type=script&lang=js"

import "./SponsorsSectionNew.vue?vue&type=style&index=0&id=1addfb07&lang=scss"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__